import React from 'react'
import BaseLevel from './base.levels'
import { BaseLevelLayoutComponent, DotsGridComponent } from '../level.components'
import { buildLevel } from '../../../services/game.services'
import barModelUtils from './utils/barModel.utils'
import numberUtils from './utils/number.utils'
import utils from './utils/utils'


export default class BarModelLevelComponent extends BaseLevel {
    onEnter = () => {
        const setting = this.props.level.settings
        const answerRequired = setting.answer_required
        let result = 0

        if (setting.show_tens) {
            if (answerRequired === 'value_1') {
                result = utils.isPowerOfTen(this.state.quantities.value_1) ? this.state.quantities.value_1 / 10 : this.state.quantities.value_1

            } else if (answerRequired === 'value_2') {
                result = utils.isPowerOfTen(this.state.quantities.value_2) ? this.state.quantities.value_2 / 10 : this.state.quantities.value_2
            } else if (answerRequired === 'value_3') {
                result = utils.isPowerOfTen(this.state.quantities.value_3) ? this.state.quantities.value_3 / 10 : this.state.quantities.value_3
            } else {
                if (this.state.operation === 'addition') {
                    result = utils.isPowerOfTen(+this.state.quantities.value_1 + +this.state.quantities.value_2 + +this.state.quantities.value_3) ? (+this.state.quantities.value_1 + +this.state.quantities.value_2 + +this.state.quantities.value_3) / 10 : +this.state.quantities.value_1 + +this.state.quantities.value_2 + +this.state.quantities.value_3
                } else {
                    result = utils.isPowerOfTen(this.state.quantities.value_1 - this.state.quantities.value_2 - this.state.quantities.value_3) ? (this.state.quantities.value_1 - this.state.quantities.value_2 - this.state.quantities.value_3) / 10 : this.state.quantities.value_1 - this.state.quantities.value_2 - this.state.quantities.value_3
                }
            }
        } else {

            if (answerRequired === 'value_1') {
                result = this.state.quantities.value_1
            } else if (answerRequired === 'value_2') {
                result = this.state.quantities.value_2
            } else if (answerRequired === 'value_3') {
                result = this.state.quantities.value_3
            } else {
                if (this.state.operation === 'addition') {
                    result = +this.state.quantities.value_1 + +this.state.quantities.value_2 + +this.state.quantities.value_3
                }else{
                    result = +this.state.quantities.value_1 - this.state.quantities.value_2 - this.state.quantities.value_3
                }
            }
        }
        if (+this.state.answer === +result) {
            this.setState({ wrongAnswer: false, answer: '?' })
            this.props.onRoundComplete()
            this.generateLevel()
            this.onRoundComplete()
        } else {
            this.setState({ wrongAnswer: true, answer: '?' })
            this.props.onRoundFail()
            this.onRoundFail()
        }
    }

    render() {
        const level = this.props.level
        const stage = this.props.stage
        const settings = level.settings
        const quantities = this.state.quantities
        const answer = this.state.answer
        const wrongAnswer = this.state.wrongAnswer
        const gameContainerWidth = this.state.gameContainerWidth
        const gameContainerHeight = this.state.gameContainerHeight
        const commutative = settings.commutative
        const answerString = settings.show_sum ? numberUtils.getNumberString(settings, quantities, answer) : answer
        let mainLayout = null
        if(commutative){
            let commutativeQuantities = {...quantities}
            commutativeQuantities.value_1 = quantities.value_2
            commutativeQuantities.value_2 = quantities.value_1
            
            mainLayout = (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: gameContainerWidth, height: gameContainerHeight }}>
                    {gameContainerHeight > 0 && barModelUtils.getLevelLayout(
                        gameContainerWidth,
                        gameContainerHeight / 2,
                        {...settings, commutative: false},
                        quantities,
                        answer)}

                    {gameContainerHeight > 0 && barModelUtils.getLevelLayout(
                        gameContainerWidth,
                        gameContainerHeight / 2,
                        {...settings},
                        commutativeQuantities,
                        answer)}

                </div>
            )
        }else{
            mainLayout = gameContainerHeight > 0 ? barModelUtils.getLevelLayout(gameContainerWidth, gameContainerHeight, settings, quantities, answer) : null
        }
        
        return (
            <BaseLevelLayoutComponent level={level} togglePause={this.props.togglePause} updateDimensions={this.updateDimensions} progress={this.props.progress || 0} stage={stage} answer={answerString} showSum={settings.show_sum} wrongAnswer={wrongAnswer} userBot={this.props.userBot} onRefresh={this.onRefresh} score={this.props.score} flash={this.state.flash} instruction={level.instruction} onExit={this.props.onExit} onUpdate={this.onUpdate} onEnter={this.onEnter}>
                <div ref="level" className='level'>
                {mainLayout}
                </div>
            </BaseLevelLayoutComponent>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/game/levels/barModel.levels.js